import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { AppLoaderComponent } from './component/app-loader/app-loader.component';

@NgModule({
  declarations: [AppLoaderComponent],
  imports: [
    CommonModule,
    MatProgressSpinnerModule,
    FlexLayoutModule
  ],
  exports: [AppLoaderComponent]
})
export class AppLoaderModule {

}
